const addItemIdToFilter = (filter, filterId, itemId) => {
    if(!_.has(filter, filterId)) {
        filter[filterId] = [itemId]
    } else if(!_.contains(filter[filterId], itemId)) {
        filter[filterId].push(itemId)
    }
    
    return filter
}

export default addItemIdToFilter